import { of } from 'rxjs';
import { map, mergeAll, filter } from 'rxjs/operators';
import { ActionType } from '@banking/ui/workflows/investments';

// FIXME(steckel): Use TypeScript parameter inference once overloaded functions
// are supported (https://github.com/microsoft/TypeScript/issues/32164)
// import type RouterService from '@ember/routing/router-service';
// type TransitionToArgs = Parameters<RouterService['transitionTo']>;

const navigateToBankingHome = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.NavigateToBankingHome), map(() => ['banking.index']));
const routerTransitions = source => of(...[navigateToBankingHome].map(transition => source.pipe(transition))).pipe(mergeAll());
export default routerTransitions;